<template>
  <v-row density="compact">
    <v-col cols="12" sm="6">
      <v-text-field
        :model-value="rule.config.term"
        density="compact"
        hide-details
        variant="outlined"
        label="Tenkan-sen days"
        @update:model-value="updateConfig('term', $event)"
      />
    </v-col>
    <v-col cols="12" sm="6">
      <v-text-field
        :model-value="rule.config.term2"
        density="compact"
        hide-details
        variant="outlined"
        label="Kijun-sen days"
        @update:model-value="updateConfig('term2', $event)"
      />
    </v-col>
    <v-col cols="12" sm="6">
      <v-text-field
        :model-value="rule.config.term3"
        density="compact"
        hide-details
        variant="outlined"
        label="Senkou days"
        @update:model-value="updateConfig('term3', $event)"
      />
    </v-col>
    <v-col cols="12" sm="12">
      <v-select
        :model-value="rule.config.target"
        :items="mappings"
        item-value="id"
        item-title="description"
        label="Field to evaluate"
        hint=""
        density="compact"
        hide-details
        variant="outlined"
        @update:model-value="updateConfig('target', $event)"
      />
    </v-col>
    <v-col cols="12" sm="12">
      <v-select
        :model-value="rule.config.action"
        :items="actions"
        item-value="id"
        item-title="description"
        label="Action"
        hint=""
        density="compact"
        hide-details
        variant="outlined"
        @update:model-value="updateConfig('action', $event)"
      />
    </v-col>
    <v-col cols="12" sm="12">
      <v-select
        :model-value="rule.config.comparison"
        :items="mappings"
        item-value="id"
        item-title="description"
        label="Field to compare to"
        hint=""
        density="compact"
        hide-details
        variant="outlined"
        @update:model-value="updateConfig('comparison', $event)"
      />
    </v-col>
    <v-col v-if="rule.config.action == 5 || rule.config.action == 6" cols="12" sm="6">
      <v-text-field
        :model-value="rule.config.days"
        density="compact"
        hide-details
        variant="outlined"
        label="Trending Days"
        @update:model-value="updateConfig('days', $event)"
      />
    </v-col>
  </v-row>
</template>

<script>
// Modules
import { mapFields } from '@/store/helpers'

export default {
  components: {},
  props: {
    rule: { type: Object, required: true }
  },
  emits: ['update:rule'],
  data() {
    return {
      actions: [
        { id: 1, description: 'Crossed Above' },
        { id: 2, description: 'Crossed Below' },
        { id: 3, description: 'Is Above' },
        { id: 4, description: 'Is Below' },
        { id: 5, description: 'Trending Up' },
        { id: 6, description: 'Trending Down' },
        { id: 7, description: 'Up Relative to' },
        { id: 8, description: 'Down Relative to' }
      ],
      mappings: [
        { id: 1, description: 'Closing Price' },
        { id: 2, description: 'Tenkan' },
        { id: 3, description: 'Kijun' },
        { id: 4, description: 'Chikou' },
        { id: 5, description: 'Senkou Span A' },
        { id: 6, description: 'Senkou Span B' },
        { id: 7, description: 'Cloud' }
      ],
      editedTa: {
        enabled: true,
        term: '9',
        term2: '26',
        term3: '52',
        target: 1,
        comparison: 2,
        days: 5,
        action: 1
      },
      defaultTa: {
        enabled: true,
        term: '9',
        term2: '26',
        term3: '52',
        target: 1,
        comparison: 2,
        days: 5,
        action: 1
      }
    }
  },

  computed: {
    ...mapFields({
      appcriteria: 'app.whaleTraderCriteria',
      criteria: 'app.whaleTraderCriteria.signals.trend_signal',
      enabled: 'app.whaleTraderCriteria.signals.trend_signal.enabled',
      signalView: 'app.signalView',
      exit_time_periods: 'app.exit_time_periods'
    })
  },

  watch: {},

  mounted() {
    if (!this.rule.config || !this.rule.config.rule_type || this.rule.trend != 'ichimoku') {
      this.$emit('update:rule', { ...this.rule, config: Object.assign({}, this.defaultTa) })
    }
  },

  methods: {
    updateConfig(key, value) {
      this.$emit('update:rule', { ...this.rule, config: { ...this.rule.config, [key]: value } })
    }
  }
}
</script>
